export default __webpack_public_path__ + "static/media/GA_Zoom-3.fdb65153.wav";